<template>
  <div class="container flex grow flex-col items-center gap-4 sm:gap-8 pb-16">
    <div class="text-2xl font-semibold tracking-tight">
      {{ $t('products.bottle.add_extra_bottle') }}
    </div>
    <div class="flex-center grow flex-col rounded-2xl bg-white border border-neutral-300 sm:flex-row max-w-screen-md items-stretch">
      <div class="flex-center bg-neutral-100 rounded-2xl">
        <img
          class="h-44 sm:w-64 sm:h-64 aspect-square object-contain"
          src="https://cdn.shopify.com/s/files/1/1209/5722/files/shaker-bottle-green.png?width=760&v=1728677598"
          alt="Shaker Bottle"
          width="760"
          height="760"
        >
      </div>
      <div
        v-if="product && selectedVariant"
        class="flex flex-col grow justify-center gap-4 p-8"
      >
        <template v-if="product.variants && product.variants.length > 1">
          <div class="flex items-center justify-between w-full">
            <h3 class="font-semibold">
              {{ $t('products.bottle.select_color') }}
            </h3>
            <div class="flex items-center space-x-1">
              <div
                v-for="variant in product.variants"
                :key="variant.id"
                class="flex items-center"
              >
                <button
                  v-if="variant.available"
                  class="tooltip whitespace-nowrap"
                  :class="selectedVariant.id == variant.id && 'selected'"
                  @click.prevent="selectedVariant = variant"
                >
                  <div :class="variant.title.toLowerCase()" />
                  <span>{{ variantTitle(variant.title) }}</span>
                </button>
                <div
                  v-else
                  class="tooltip whitespace-nowrap cursor-not-allowed"
                >
                  <div class="purple opacity-50" />
                  <span>{{ variantTitle(variant.title) }} - Sold Out</span>
                </div>
              </div>
            </div>
          </div>
          <hr>
        </template>
        <div class="sale-pointers grid grid-cols-2 gap-3 text-left whitespace-nowrap">
          <div class="highlight">
            {{ $t('products.bottle.bpa_free') }}
          </div>
          <div class="highlight">
            {{ $t('products.bottle.fits_cup_holder') }}
          </div>
          <div class="highlight">
            {{ $t('products.bottle.shaker_lid') }}
          </div>
          <div class="highlight">
            {{ $t('products.bottle.strong_and_durable') }}
          </div>
          <div class="highlight">
            {{ $t('products.bottle.convenient_fill_line') }}
          </div>
          <div class="highlight">
            {{ $t('products.bottle.dishwasher_safe') }}
          </div>
        </div>
        <add-to-cart-button
          :variant="selectedVariant"
          :gtm-label="`${product.title} - ${selectedVariant.title}`"
          @click.prevent="$cart.add(product, selectedVariant)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useThemeStore } from '@/stores'
import AddToCartButton from '@/components/shared/add-to-cart-button.vue'
import type { Variant } from '@/types/shopify'
const store = useThemeStore()
const { blenderBottleProduct: product } = storeToRefs(store)
const selectedVariant = ref<Variant | undefined>(product.value?.variants?.[0])
const variantTitle = (string: string) => string.replace('Shaker Bottle', ' ')
</script>
